import { Component, Input } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'ng-casto-complementary-product-chips',
  templateUrl: './complementary-product-chips.component.html',
})
export class ComplementaryProductChipsComponent {
  @Input() selectedFilters$!: BehaviorSubject<TreeNode[]>;

  protected removeFilter(filterToRemove: TreeNode) {
    let newFilters = this.selectedFilters$.value.filter(filter => filter !== filterToRemove);
    //Si c'est une sous catégorie, on retire le parent en même temps
    if ((filterToRemove.data.type = 'subcategory')) {
      newFilters = newFilters.filter(filter => filter.key !== filterToRemove.data.parentKey);
    }
    //Si le filtre a des enfants, on retire tous ses enfants
    if (filterToRemove.children?.length > 0) {
      newFilters = newFilters.filter(
        filter => !filterToRemove.children.some(children => children.label === filter.label)
      );
    }
    this.selectedFilters$.next(newFilters);
  }

  get displayedFilters() {
    return this.selectedFilters$.value.filter(filter => !filter.children || filter.key === 'all');
  }
}
